export const DESIGN_STUDIO_PATH = '/uslugi/proektirovanie-i-dizayn/proektirovanie-interera/';

export const DESIGN_STUDIO_CDN_PATH =
  'https://cdn.lemanapro.ru/lmru/image/upload/f_auto,c_pad,b_auto,d_photoiscoming.png/fudzi/elbrus/images/landings/design-studio';

export const DESIGN_STUDIO_HEADER_CDN_PATH =
  'https://cdn.lemanapro.ru/lmru/image/upload/c_pad,b_auto,d_photoiscoming.png/fudzi/elbrus/images/landings/design-studio';

export const DESIGN_STUDIO_SIGN_UP_HREF = '/zapis-onlayn/?department_no=30&region_id=';

export const DESIGN_STUDIO_ELEMENT_BLOCK = 'landingDesign';

export const DESIGN_STUDIO_LANDING_NAME = 'design-studio';
